var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" IRTP Lock Warning ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "p",
              {
                staticClass: "mb-2"
              },
              [
                _vm._v(
                  ' Saving these changes will result in "' +
                    _vm._s(_vm.domain) +
                    '" being '
                ),
                _c("b", [_vm._v("transfer locked for 60 days")]),
                _vm._v(". ")
              ]
            ),
            _c(
              "p",
              {
                staticClass: "mb-2"
              },
              [
                _vm._v(
                  " If you plan on transferring your domain soon, use the option below to bypass the transfer lock. If you have any questions please contact Support. "
                )
              ]
            ),
            _c("v-checkbox", {
              attrs: {
                color: "primary",
                "true-value": 1,
                "false-value": 0,
                label: "Bypass Transfer Lock",
                "hide-details": ""
              },
              model: {
                value: _vm.bypass_irtp,
                callback: function callback($$v) {
                  _vm.bypass_irtp = $$v
                },
                expression: "bypass_irtp"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.confirm
                }
              },
              [_vm._v(" Confirm ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }